import React from 'react';
import { Flex, Image } from 'antd';
import { Link } from 'react-router-dom';
import { paths } from '../consts';
import { useResizeWidthWindow } from './hook/useResizeWidthWindow';

interface ILogo {
  size?: string;
}

export const LogoBC: React.FC<ILogo> = ({ size }) => {
  const width = size || (useResizeWidthWindow() > 700 ? 150 : 80);

  return (
        <Link to={paths.MAIN} style={{ display: 'block' }}>
            <Flex>
                <Image src={'../img/logoBC-short.png'} preview={false} width={width}
                       style={{ fontSize: size }}/>
            </Flex>
        </Link>
  );
};
